import { render, staticRenderFns } from "./HorseStatistics.vue?vue&type=template&id=0f762e3e&scoped=true"
import script from "./HorseStatistics.vue?vue&type=script&lang=js"
export * from "./HorseStatistics.vue?vue&type=script&lang=js"
import style0 from "./HorseStatistics.vue?vue&type=style&index=0&id=0f762e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f762e3e",
  null
  
)

export default component.exports